import { MAIN_SCREEN, SCREEN } from '../../constant'
import {
  getDefaultCompanyProfile,
  getPanelCompanyProfile,
  getPanelListCompanyProfile,
} from './companyProfile'
import {
  getPanelCorporatePerformanceScore,
  getPanelListCorporatePerformanceScore,
} from './corporatePerformanceScore'
import {
  getPanelCorporateRiskScore,
  getPanelListCorporateRiskScore,
} from './corporateRiskScore'
import {
  getDefaultFinancialAnalysis,
  getPanelFinancialAnalysis,
  getPanelListFinancialAnalysis,
} from './financialAnalysis'
import {
  getDefaultFinancialStatement,
  getPanelFinancialStatement,
  getPanelListFinancialStatement,
} from './financialStatement'
import {
  getDefaultIndustryAnalysis,
  getPanelIndustryAnalysis,
  getPanelListIndustryAnalysis,
} from './industryAnalysis'
import {
  getDefaultIndustryOverview,
  getPanelIndustryOverview,
  getPanelListIndustryOverview,
} from './industryOverview'
import {
  getDefaultOwnershipAndGroup,
  getPanelListOwnershipAndGroup,
  getPanelOwnershipAndGroup,
} from './ownershipAndGroup'
import { getDefaultScore } from './score'

export const getPanelCompanyAnalysis = ({
  screen,
  panel,
  setting = {},
  currencyUnitFs,
  settingFs = {},
  companyType,
}) => {
  switch (screen) {
    case SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS:
      return getPanelFinancialAnalysis(panel, setting.viewBy)
    case SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_STATEMENT:
      return getPanelFinancialStatement(setting, currencyUnitFs, settingFs)
    case SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].COMPANY_PROFILE:
      return getPanelCompanyProfile(panel)
    case SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].OWNERSHIP_AND_GROUP:
      return getPanelOwnershipAndGroup(panel, setting)
    case SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW:
      return getPanelIndustryOverview(panel, setting)
    case SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS:
      return getPanelIndustryAnalysis(panel, setting, companyType)
    case SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_RISK_SCORE:
      return getPanelCorporateRiskScore(panel, setting)
    case SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_PERFORMANCE_SCORE:
      return getPanelCorporatePerformanceScore(panel, setting)
    default:
      return {}
  }
}

export const getPanelListCompanyAnalysis = (companyType) => {
  return [
    ...getPanelListCompanyProfile(),
    ...getPanelListOwnershipAndGroup(),
    ...getPanelListFinancialStatement(),
    ...getPanelListFinancialAnalysis(companyType),
    ...getPanelListCorporateRiskScore(companyType),
    ...getPanelListCorporatePerformanceScore(companyType),
    ...getPanelListIndustryOverview(),
    ...getPanelListIndustryAnalysis(companyType),
  ]
}

export const getDefaultCompanyAnalysis = (companyType) => {
  return [
    ...getDefaultCompanyProfile(),
    ...getDefaultOwnershipAndGroup(),
    ...getDefaultFinancialStatement(),
    ...getDefaultFinancialAnalysis(companyType),
    ...getDefaultScore(companyType),
    ...getDefaultIndustryOverview(),
    ...getDefaultIndustryAnalysis(companyType),
  ]
}
